import { BasicInfoFields } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { useGetFormData } from 'cng-common/features/form'

import { PartnerEditorFormKeys } from '../../../../configs'

interface IUseBasicInfoMandatoryAttachmentsParams {
  hasActiveAgreement: boolean
}

export const useBasicInfoMandatoryAttachments = ({
  hasActiveAgreement,
}: IUseBasicInfoMandatoryAttachmentsParams) => {
  const [{ formData, modifiedFields }] = useGetFormData<IPartner>(PartnerEditorFormKeys.BasicInfo)

  const isAmericanPartner = formData?.country === 'USA'
  const isCommunicationNameChanged = modifiedFields.includes(BasicInfoFields.CommunicationName)
  const isTaxIdChanged = modifiedFields.includes(BasicInfoFields.TaxId)

  const isAttachmentRequired =
    hasActiveAgreement &&
    ((isAmericanPartner && isCommunicationNameChanged) || (!isAmericanPartner && isTaxIdChanged))

  return { isAttachmentRequired }
}
